import {
  IMediaModel,
  DataProvider,
  MediaStore,
  useSelector,
  useDispatch,
} from "@nf/common";

export const useFavoriteToggle = (media?: IMediaModel) => {
  const dispatch = useDispatch();

  const isFavorite = useSelector((state) =>
    state.user.favorites?.find((fav) => fav.AssetId === media?.Id)
  );

  const toggleFavorite = () => {
    if (!media?.Id) return;

    if (isFavorite)
      DataProvider.removeFromMyList(media.Id)
        .then(() =>
          dispatch(MediaStore.Actions.removeFromFavoritesListAction(media.Id))
        )
        .catch((error) => console.error(error));
    else
      DataProvider.addToMyList(media.Id)
        .then((media) =>
          dispatch(MediaStore.Actions.addToFavoritesListAction(media))
        )
        .catch((error) => console.error(error));
  };

  return { isFavorite, toggleFavorite };
};
